//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import Loader from "../../loaders/Loader";
	import GameBox from "../games/GameBox";
	export default {
		name: "competition-teams",
		components: {GameBox, Loader},
		props: ['id'],
        data() {
			return {
				teams: [],
                games: [],
                loader: true,
                teamsInfos: [],
                teamVisible: null,

                gamesLoaded: false,
                teamsLoaded: false,
            }
        },
        mounted() {
            this.loadTeams();
            this.loadGames();
        },

        methods: {
			loadTeams() {
				window.Api.get('rugby/competitions/' + this.id + '/teams').then(response => {
					let teams = response.data.teams;
					this.teams = teams;
					teams.forEach((team) => {
						this.teamsInfos.push({team: null, stats: null});
                    });
					this.teamsLoaded = true;
					this.loader = false;
                });
            },

            loadGames() {
                window.Api.get('rugby/competitions/' + this.id + '/games').then(response => {
					if( response.success ) {
						this.games = response.data.games;
					}
					this.gamesLoaded = true;
                });
            },

            getTeamInfos(index, id) {
				if( this.teamVisible === id ) {
					this.teamVisible = null;
                } else {
					if( this.teamsInfos[index].team === null && this.teamsInfos[index].stats === null ) {
                        window.Api.get('rugby/competitions/' + this.id + '/' + id).then(response => {
							this.teamsInfos[index].team = response.data.team;
							this.teamsInfos[index].stats = response.data.stats;
							this.teamVisible = id;
						});
					} else {
						this.teamVisible = id;
					}
                }
            }
        }
	}
